<template>
  <el-row class="_login-app">
    <el-col :span="$store.state.isMB ? 24 : 12" :offset="$store.state.isMB ? 0 : 12">
      <div style="display:flex;flex-direction:column;justify-content:center;height:100vh;">
        <div class="login-box">
          <div class="title">欢迎使用{{ $store.state.sys.title }}</div>
          <div class="content">
            <el-tabs v-model="tabName" class="tab">
              <el-tab-pane name="scan">
                <div slot="label" class="tab-btn">扫码登录</div>
              </el-tab-pane>
              <el-tab-pane name="password">
                <div slot="label" class="tab-btn">密码登录</div>
              </el-tab-pane>
            </el-tabs>
            <div class="scan" v-if="tabName == 'scan'">
              <div style="margin-bottom: 20px;">
                <el-image style="height: 120px;width: 120px;" :src="qrCode" />
              </div>
              <div>请使用拼多多商家APP进行扫描授权登录</div>
            </div>
            <div class="password" v-if="tabName == 'password'">
              <el-form ref="form" :model="data" size="large" :rules="rules" @keyup.enter.native="login">
                <el-form-item prop="LoginId">
                  <el-input v-model="data.LoginId" placeholder="请输入用户名" />
                </el-form-item>
                <el-form-item prop="Pwd">
                  <el-input show-password type="password" v-model="data.Pwd" placeholder="请输入密码" />
                </el-form-item>
                <el-button size="large" :loading="loading" type="primary" style="width:100%;"
                  @click="login">登录</el-button>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>

export default {
  components: {},
  data() {
    return {
      api: require("@/api/sy/user").default,
      loading: false,
      data: {
        LoginId: "",
        Pwd: "",
      },
      tabName: "scan",
      qrCode: "https://cdn4.codesign.qq.com/prototypes/2024/03/22/Yyg5Z24px8Qo03Z2lKv22/fg0vjemgcicsecmr/c57e1735f5daba008e0921d9fc2b83d7.svg",
      rules: {
        LoginId: [{ required: true, message: "请输入用户名" }],
        Pwd: [{ required: true, message: "请输入密码" }],
      },
    };
  },
  created() { },
  mounted() {
    let token = localStorage.getItem("token");
    if (token) {
      this.$store.dispatch("refreshToken").then((res) => {
        if (res.Code == 0) {
          this.$router.push("/").catch((err) => { });
        }
      });
    }
  },
  methods: {
    login() {
      this.$refs.form.validate().then((res) => {
        if (!res) return false;
        this.loading = true;
        this.$store.dispatch("login", this.data).then((res) => {
          // if (res.Data.ChangePwd == true) {
          //   this.$store.dispatch("changeSetting", {
          //     key: "fixedHeader",
          //     value: false,
          //   });
          //   this.$router.push("/password").catch((err) => {});
          // } else {
          // console.log("login", res);
          this.$router.push("/").catch((err) => { });
          // }
        }).catch((res) => {
          this.$message.error(res.Msg);
          this.loading = false;
          console.log(res);
        });
      }).catch((res) => {
        console.log(res);
      });
    },
  },
};
</script>
<style lang="scss">
._login-app {
  @media screen and (min-width: 481px) {
    // background-image: url("../assets/bgPic.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
  }

  background: #001529;
  // background: linear-gradient(-30deg, #1736a0 0%, #6890e5 100%);

  .login-box {
    z-index: 1000;
    border-radius: 12px;
    width: 500px;
    margin: 0px auto;
    border: 1px solid #ebeef5;
    padding: 40px 25px 30px;
    background-color: #fff;
    box-shadow: 2px 2px 12px 0 rgba(0, 0, 0, 0.1);

    @media screen and (max-width: 480px) {
      width: 80%;
    }

    .title {
      height: 50px;
      font-weight: bold;
      font-size: 32px;
      text-align: center;
      letter-spacing: 1px;
      margin-bottom: 20px;

      @media screen and (max-width: 480px) {
        font-size: 18px;
      }
    }

    .content {
      padding: 0 40px;
      height: 250px;

      .tab {
        width: 200px;
        margin: auto;
        margin-bottom: 15px;

        .el-tabs__item {
          padding: 0;
        }

        .tab-btn {
          width: 100px;
          text-align: center;
        }
      }

      .scan {
        text-align: center;
      }
    }
  }
}
</style>